import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./message-detail.css";

import {
  showGlobalMessage,
  showGlobalSuccess,
} from "../../../services/globalMessage";


const API_BASE = "https://api.chbtkd.ir";


const MessageDetail = () => {

  const location = useLocation();
  const navigate = useNavigate();


  const [message, setMessage] = useState(null);
  const [conversation, setConversation] = useState([]);
  const [reply, setReply] = useState("");
  const [sendingReply, setSendingReply] = useState(false);
  const [error, setError] = useState("");



  const getToken = () => {

    const role =
      localStorage.getItem("user_role");

    return localStorage.getItem(
      `${role}_token`
    );

  };




  const formatDate = (date) => {

      if (!date)
          return "-";


      const d = new Date(date);


      if (isNaN(d.getTime()))
          return "-";


      return d.toLocaleDateString(
          "fa-IR",
          {
              year:"numeric",
              month:"2-digit",
              day:"2-digit"
          }
      );

  };





  useEffect(() => {

    const params =
      new URLSearchParams(
        location.search
      );


    const id =
      params.get("id");



    fetch(
      `${API_BASE}/api/notifications/inbox/`,
      {
        headers: {
          Authorization:
          `Bearer ${getToken()}`
        }
      }
    )

    .then(res => res.json())

    .then(data => {


      const item =
        data.find(
          x =>
          x.id === Number(id)
        );


      if (!item)
        return;


      setMessage(item);



      setConversation([

        {
          type:"admin",
          text:item.body,
          date:item.created_at
        },

        ...(item.replies || []).map(reply => ({

          type: reply.type,

          text: reply.text,

          date: reply.date

        }))

      ]);



      if (!item.is_read) {

        fetch(
          `${API_BASE}/api/notifications/message/${id}/read/`,
          {
            method:"POST",
            headers:{
              Authorization:
              `Bearer ${getToken()}`
            }
          }
        );

      }

      window.dispatchEvent(
        new Event("messagesUpdated")
      );

 

      setMessage({
        ...item,
        is_read:true,
        has_new_reply:false
      });


    })

    .catch(error => {

      console.error(
        "MESSAGE_DETAIL_ERROR",
        error
      );

    });


  }, [location.search]);








  const deleteMessage = async () => {

    try {


      const response =
        await fetch(

          `${API_BASE}/api/notifications/message/${message.id}/delete/`,

          {
            method: "POST",

            headers: {
              Authorization:
              `Bearer ${getToken()}`
            }
          }

        );



      if (response.ok) {


        showGlobalSuccess(
          "پیام حذف شد"
        );


        const role =
          localStorage.getItem(
            "user_role"
          );


        navigate(
          `/dashboard/${role}?section=messages`
        );


      }

      else {

        showGlobalMessage({

          type: "error",

          title: "خطا",

          message:
          "حذف پیام انجام نشد"

        });

      }


    }

    catch {


      showGlobalMessage({

        type: "error",

        title: "خطا",

        message:
        "خطا در حذف پیام"

      });


    }


  };







  const confirmDelete = () => {

    showGlobalMessage({

      type: "confirm",

      title: "تأیید حذف",

      message:
      "آیا از حذف این پیام مطمئن هستید؟",

      onConfirm:
      deleteMessage,

      onCancel:
      () => {}

    });

  };








  const sendReply = async () => {


    if (!reply.trim())
      return;



    setSendingReply(true);

    setError("");



    try {


      const response =
        await fetch(

          `${API_BASE}/api/notifications/message/${message.id}/reply/`,

          {

            method: "POST",

            headers: {

              "Content-Type":
              "application/json",

              Authorization:
              `Bearer ${getToken()}`

            },


            body: JSON.stringify({

              text: reply

            })

          }

        );




      if(response.ok){

        showGlobalSuccess(
          "پاسخ ارسال شد"
        );


        setConversation([
          ...conversation,

          {
            type:"user",
            text:reply,
            date:new Date()
          }

        ]);


        setReply("");

      }

      else {


        const data =
          await response.json();


        setError(

          data.error ||
          "ارسال پاسخ ناموفق بود"

        );

      }


    }

    catch {


      setError(
        "خطا در ارسال پاسخ"
      );


    }

    finally {

      setSendingReply(false);

    }


  };







  if (!message) {

    return (

      <div
        className="detail-container"
        dir="rtl"
      >

        در حال دریافت پیام...

      </div>

    );

  }








  return (

    <div
      className="detail-container"
      dir="rtl"
    >


      <div className="detail-header">


        <div className="detail-title">


          <div className="mail-icon">
            📩
          </div>


          <div>

            <h1>
              {message.title}
            </h1>


            <div className="detail-info">

              پیام دریافتی

            </div>


          </div>


        </div>





        <div className="detail-actions">


          <button

            className="back-btn"

            onClick={() =>
              navigate(-1)
            }

          >

            ← بازگشت

          </button>





          <button

            className="delete-btn"

            onClick={confirmDelete}

          >

            🗑 حذف پیام

          </button>


        </div>


      </div>








      <div className="message-box">


        <div className="message-box-header">

          متن پیام

        </div>



        <div className="message-box-body">

          {message.body}

        </div>




        <div className="message-time">

          📅 ارسال:

          {" "}

          {formatDate(message.created_at)}

        </div>


      </div>









      {

      message.allow_reply

      ?

      <div className="conversation-box">


        <div className="conversation">


          {

          conversation.map(

            (item,index) => (


              <div

                key={index}

                className={
                  item.type === "admin"
                  ?
                  "chat-row admin"
                  :
                  "chat-row user"
                }

              >


                <div className="chat-bubble">


                  <div>

                    {item.text}

                  </div>



                  <div className="chat-date">

                    {formatDate(item.date)}

                  </div>


                </div>


              </div>


            )

          )

          }


        </div>







        <div className="reply-card">


          <h3>
            💬 پاسخ به پیام
          </h3>



          <textarea

            value={reply}

            onChange={(e) =>
              setReply(
                e.target.value
              )
            }

            placeholder="پاسخ خود را بنویسید..."

          />




          {

          error &&

          <div className="reply-error">

            {error}

          </div>

          }





          <button

            className="reply-send"

            onClick={sendReply}

            disabled={
              sendingReply
            }

          >

            {

            sendingReply

            ?

            "در حال ارسال..."

            :

            "ارسال پاسخ"

            }


          </button>


        </div>


      </div>


      :

      <div className="no-reply">

        🔒 امکان پاسخ به این پیام فعال نیست.

      </div>


      }


    </div>

  );

};


export default MessageDetail;